<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.go(-1)" class="ml-2 cursor-pointer"> <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Pago de requerimientos</span>
                    </h4>
                    <div class="card-container m-b-30">
                        <div class="card-body">
                            <div class="searchResult">
                                <div class="row" v-if="Object.keys(requerimientos).length > 0">
                                    <div v-for="item in requerimientos" class="col-12 mb-2 resultItem">
                                        <div>
                                            <span>
                                                <b>Req No.:</b> {{item.requerimiento}}
                                            </span>
                                            <span class="ml-4">
                                                <b>Monto:</b> {{item.moneda}} {{ Numbro((item.monto) ? item.monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                                            </span>
                                        </div>
                                        <div class="mt-2 searchResultBadges">
                                            <div class="row m-0">
                                                <div class="col-5">
                                                    <div class="miniInfo">
                                                        <span>Pago No.</span> {{item.numero_pago}}
                                                    </div>
                                                </div>
                                                <div class="col-7">
                                                    <div class="miniInfo">
                                                        <span>Días vencido: </span> {{item.dias_vencido}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <inicio-pago v-if="typeof item.indprotegido !== 'undefined' && item.indprotegido === 'N'" typepago="prima" :pago-pendiente="(typeof item.pPnd !== 'undefined') ? item.pLF : 0" :onlyfact="(typeof item.pPnd !== 'undefined') ? item.pLF : 'none'" :pago-log="(typeof item.pL !== 'undefined') ? item.pL : false" :item="item" :pagandoref="pagandoref" @pagandoReferencia="activarPagandoRef"></inicio-pago>
                                            <div v-else class="text-center font-weight-bold text-danger">
                                                Requerimiento bloqueado para pago
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center text-muted">
                                    <div v-if="msg !== ''">
                                        {{msg}}
                                    </div>
                                    <div v-else>
                                        No se encontraron requerimientos
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";

export default {
    props: [],
    components: {
        Pago,
        Layout,
        InicioPago,
    },
    data() {
        return {
            Valid: {},
            requerimientos: {},
            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',

            pagandoref: 0,
            pagosToApply: {},
            msg: ""
        };
    },
    mounted() {

        const self = this;

        if (parseInt(this.$route.params.poliza) > 0) {

            //const url = new URL(window.location.href);
            //this.polizaNo = url.searchParams.get("poliza");
            //this.nombre = url.searchParams.get("nombre");
            //this.direccion = url.searchParams.get("direccion");

            API.send('GET', 'consulta/requerimientos/poliza?poliza=' + this.$route.params.poliza, null,
                function (response) {
                    if (response.status) {
                        self.requerimientos = (typeof response.data === "object") ? response.data : {};
                    }
                    else {
                        //API.showErrorNotify(response.msg);
                        self.msg = response.msg;
                    }
                    store.dispatch('coreHideLoading');
                },
                function (response) {
                    self.msg = response.msg;
                    alert('Error de conexión, por favor intente de nuevo');
                });
        }
    },
    methods: {
        Numbro,
        dayjs,
        activarPagandoRef(data) {
            this.pagandoref = data;
        },
        cancelarPago() {
            this.pagar = 0;
        },
    },
};
</script>
